import React from 'react';
import Box from '@mui/material/Box';
import CustomCircularProgress from '../customCircularProgress/customCircularProgress.component';

interface DetailPageProps {
  /** Shows the shared loader instead of the content. */
  loading?: boolean;
  children?: React.ReactNode;
}

/**
 * Root of every detail / profile view: header, sections and the metadata
 * footer stack with even spacing, so views don't need dividers between them.
 */
export const DetailPage = ({ loading = false, children }: DetailPageProps) => {
  if (loading) return <CustomCircularProgress />;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        width: '100%',
        minWidth: 0,
        mt: 1,
        pb: 4,
      }}
    >
      {children}
    </Box>
  );
};

/**
 * Lays sections out side by side when there's room. Keyed on the available
 * width rather than the viewport, so it also collapses inside the preview modal.
 */
export const DetailGrid = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(420px, 100%), 1fr))',
      gap: 2.5,
      alignItems: 'start',
    }}
  >
    {children}
  </Box>
);
